import React from "react";
import {
  BuildingFloorItem,
  NearBuildingItem,
} from "../../../services/buildingServices";
import {
  IncommodityCategory,
  IncommodityCreateRequest,
} from "../../../services/centerServices";

import CommonButton from "../../Button";
import HorizontalRule from "../../Rule/Horizontal";
import BottomGroup from "../../Button/Group";
import HistoryDetailRow from "../../History/DetailRow";

type Props = {
  incommodityCreate: Partial<IncommodityCreateRequest>;
  selectedCategory: IncommodityCategory | null;
  scheduleMode: string;
  scheduleDatetime: Date | undefined;
  onClickPrev: () => void;
  onClickNext: () => void;
  selectedBuilding?: NearBuildingItem;
  selectedFloor?: BuildingFloorItem;
};

export default function ConfirmReport({
  incommodityCreate,
  selectedCategory,
  scheduleMode,
  scheduleDatetime,
  onClickPrev,
  onClickNext,
  selectedBuilding,
  selectedFloor,
}: Props) {
  return (
    <div className="w-full">
      <div className="px-5 pb-5">
        <div className="flex text-[26px] font-light h-[58px]">
          <span className="font-medium">접수 정보</span>를 확인해주세요.
        </div>
        <HorizontalRule margin="0" className="bg-black" />
        <div className="flex flex-col pb-20">
          <HistoryDetailRow title="접수 위치">
            {`${selectedBuilding?.buildingName} ${selectedFloor?.floorName}`}
            {incommodityCreate.location && (
              <>
                <br />
                <div className="break-all">{incommodityCreate.location}</div>
              </>
            )}
          </HistoryDetailRow>
          <HistoryDetailRow title="접수 분류">
            {selectedCategory?.serviceItemTypeName && (
              <div className=" rounded pl-1.5 pr-2 py-1 bg-brand-category_tag w-fit flex items-center gap-1.5 text-sm">
                <div className="w-1 h-1 rounded-full bg-white leading-[18px]"></div>
                {selectedCategory?.serviceItemTypeName}
              </div>
            )}
            {selectedCategory?.serviceName}
          </HistoryDetailRow>
          <HistoryDetailRow title="처리 희망시간">
            {scheduleMode === "asap"
              ? "즉시 신청"
              : `${scheduleDatetime
                  ?.toLocaleString()
                  .split(":")
                  .slice(0, 2)
                  .join(":")} 이후`}
          </HistoryDetailRow>

          <HistoryDetailRow title="상세 내용">
            {incommodityCreate.description ?? ""}
          </HistoryDetailRow>
        </div>
      </div>

      <BottomGroup>
        <div className="flex">
          <CommonButton
            className="p-4 brightness-90 opacity-70 w-[100px] rounded-none h-bottom-button"
            onClick={onClickPrev}
            variant="grey"
          >
            이전
          </CommonButton>
          <CommonButton
            className="p-4 w-full rounded-none "
            onClick={onClickNext}
          >
            접수할게요
          </CommonButton>
        </div>
      </BottomGroup>
    </div>
  );
}
